import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';
import { Chip, Tooltip } from '@mui/material';
import React from 'react';
import { Conflict } from '../../types';
import { getConflictSeverityColor } from '../utils/conflictDetection';

interface ConflictBadgeProps {
  conflict: Conflict;
  size?: 'small' | 'medium';
  showLabel?: boolean;
}

export const ConflictBadge: React.FC<ConflictBadgeProps> = ({ conflict, size = 'small', showLabel = true }) => {
  const getSeverityIcon = () => {
    switch (conflict.severity) {
      case 'high':
        return <ErrorIcon fontSize="small" />;
      case 'medium':
        return <WarningIcon fontSize="small" />;
      case 'low':
        return <InfoIcon fontSize="small" />;
    }
  };

  const getLabel = () => {
    if (!showLabel) return '';
    return conflict.severity.charAt(0).toUpperCase() + conflict.severity.slice(1);
  };

  return (
    <Tooltip title={conflict.message} arrow>
      <Chip
        icon={getSeverityIcon()}
        label={getLabel()}
        size={size}
        sx={{
          backgroundColor: getConflictSeverityColor(conflict.severity),
          color: 'white',
          '& .MuiChip-icon': {
            color: 'white',
          },
        }}
      />
    </Tooltip>
  );
};

export default ConflictBadge;
